import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { StyledButton } from '../../../buttons/Button/Button.styled'
import { breakpoint, calcRem } from '../../../__styling'
import { palette } from '../../EmailPreference.styled'

export const StyledBody = styled('div')(({ theme }) => ({
    padding: calcRem(16, 0),
    marginTop: calcRem(16),
    borderTop: `1px solid ${palette(theme)?.borders.divider}`,

    [breakpoint('md')]: {
        paddingBottom: calcRem(40),
        paddingTop: calcRem(24),
    },
    [breakpoint('lg')]: {
        paddingBottom: calcRem(40),
        paddingTop: calcRem(24),
    },
}))

export const StyledBoldP = styled('p')({
    fontWeight: 700,
    fontSize: calcRem(22),
    lineHeight: calcRem(24),
})

export const StyledCancelButton = styled(StyledButton)(({ theme }) => ({
    background: tokens.thewest.colors.palette.white,
    width: calcRem(343),
    textTransform: 'none',
    border: '1px solid',
    borderColor: tokens.thewest.colors.brand,
    color: tokens.thewest.colors.brand,
    display: 'block',
    '&:hover': {
        background: tokens.thewest.colors.brand,
    },
}))
